/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    gtag?: (...args: any[]) => void;
  }
}

export const AnalyticsProvider = () => {
  const pathname = usePathname();

  useEffect(() => {
    window.gtag?.('config', 'G-XXX', { page_path: pathname });
    window.fbq?.('track', 'PageView');
  }, [pathname]);

  return null;
};
